import Container from '@material-ui/core/Container';
import { withStyles } from '@material-ui/core/styles';

export default withStyles({
  root: {
    margin: 'unset',
  },
})(Container);
